import { useEffect, useState } from 'react';
import {
  prepareExternalSlabArtwork,
  type PreparedExternalSlabArtwork,
} from '../../assets/prepareExternalSlabArtwork';

export function useExternalSlabArtwork(publicPath: string | null): PreparedExternalSlabArtwork | null {
  const [artwork, setArtwork] = useState<PreparedExternalSlabArtwork | null>(null);

  useEffect(() => {
    let cancelled = false;
    setArtwork(null);
    if (!publicPath || typeof fetch !== 'function') return undefined;

    fetch(publicPath, { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to load ${publicPath}`);
        return response.text();
      })
      .then((text) => {
        if (cancelled) return;
        setArtwork(prepareExternalSlabArtwork(text));
      })
      .catch(() => {
        if (!cancelled) setArtwork(null);
      });

    return () => {
      cancelled = true;
    };
  }, [publicPath]);

  return artwork;
}
